<template>
  <div class="tab-pane fade active show" id="will-process-content" role="tabpanel" aria-labelledby="will-process-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in sosScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

   

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

         <div class="col-md-2">
          <label for="inputEmail4" class="form-label">狀態</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectDismissStatus" >
            <option selected="selected" value="-1">全部</option>
            <option value="1">已解除</option>
            <option value="0">未解除</option>
          </select>
        </div>
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">時段</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectTimePeriod">
            <option value="-1">全部</option>
            <option value="1">日間</option>
            <option value="0">夜間</option>
          </select>
        </div>

        <div class=" d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
          <button type="button" class="btn btn-warning btn-sm rounded-pill px-3 mx-1"  @click="switchBatchEdit"
           
          >
            <i v-if="!batchStatus" class="fa fa-edit"></i> 
            <i  v-if="batchStatus" class="fas fa-times"></i>

                 {{
                  batchStatus !== true ? "開啟" : "關閉"
                }}批次處理
          </button>
          <button type="button" v-if="batchStatus" class="btn btn-info btn-sm rounded-pill px-3 mx-1"  @click="editBatchItems" data-bs-target="#processModal" >
             <i class="fa fa-pen"></i> 批次編輯  
           </button>

          <!-- <input type="checkbox" @click="toggleSelectAll" :checked="selectAll" v-if="batchStatus"> -->
        </div>
      </form>

      <h1 style="margin-top: 0px;">警報查詢與處理</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="willProcessSos" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <!-- <th width="5%">#  <button v-if="batchStatus" @change="toggleSelectAll">全選</button></th> -->
                    <!-- <th width="5%">#  <input type="checkbox" @click.stop="toggleSelectAll" :checked="selectAll" v-if="batchStatus"> </th> -->
                    <th class="text-center" width="5%">
                      <span v-if="!batchStatus">#</span> 
                      <button class="btn btn-warning btn-sm  py-0  mx-1" @click.stop="toggleSelectAll" v-if="batchStatus"> {{ selectAll ? '取消全選' : '全選' }}</button> 
                    </th>

                    <!-- <th><input type="checkbox" @change="toggleSelectAll" :checked="selectAll"></th> -->
                    <th>通報時間</th>
                    <th>風景區</th>
                    <th>位置</th>
                    <th>時段</th>
                    <th>解除警報內容</th>
                    <th>填寫帳號</th>
                    <th>填寫時間</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in emergencyEventList" :key="key" :class="tableCenterStyle ">
                    <td>{{ key + 1 }}  <input v-if="batchStatus" type="checkbox" :checked="selectAll" v-model="selectedItems" :value="item.eventId"></td>
                  

                    <!-- <td >  <input type="checkbox"></td> -->
                    <td>{{ getTime(item.eventTime) }}</td>
                    <td>{{ item.scenicAreaName }}</td>
                    <td>{{ item.placeName }}</td>
                    <td>{{ item.timePeriodContent }}</td>
                    <td>
                    {{ item.dismissContent }}
               
                        <button type="submit" class="btn btn-warning my-1" data-bs-toggle="modal"
                          data-bs-target="#processModal"  v-if="!batchStatus"  @click="selectEvent(item)">
                          <i class="fa fa-edit"></i>
                         
                        </button>

              
                    
                    </td>
                    <td>{{ getFilledAccount(item) }}</td>
                    <td>{{ getFilledTime(item) }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <!-- <div class="col">
          <div id="realAreaCarChart">
            <apexchart type="donut" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div> -->
      </div>

    </div>

    <!-- 解除警報Modal -->
    <div class="modal fade" id="processModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true" ref="processModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5" id="exampleModalCenterTitle">
              修改解除警報內容
            </div>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body h6">
            <form>
              <fieldset class="form-group">
                <div class="row">
                  <legend class="col-form-label col-sm-3 pt-0">解除原因</legend>
                  <div class="col-sm-9">
                    <!-- <div class="form-check disabled">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios3"
                        :value='CONST.REASON_FOUR' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios3">
                        {{ CONST.REASON_FOUR }}
                        <input type="text" class="form-control" id="colFormLabelLg" placeholder="請填寫事件"
                          v-model="inputEventContent" />
                      </label>
                    </div> -->
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios1"
                        :value='CONST.REASON_ONE' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios1">
                        {{ CONST.REASON_ONE }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2"
                        :value='CONST.REASON_TWO' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios2">
                        {{ CONST.REASON_TWO }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios3"
                        :value='CONST.REASON_THREE' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios3">
                        {{ CONST.REASON_THREE }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios4"
                        :value='CONST.REASON_FOUR' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios4">
                        {{ CONST.REASON_FOUR }}
                      </label>
                    </div>
                    <div class="form-check disabled">
                      <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios5"
                        :value='CONST.REASON_FIVE' v-model="dismissedContent" />
                      <label class="form-check-label" for="gridRadios5">
                        {{ CONST.REASON_FIVE }}
                        <input type="text" class="form-control" id="colFormLabelLg" placeholder="請填寫原因"
                          v-model="inputContent" />
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-bs-target="#processModal">
              取消
            </button>
            <button type="button" class="btn btn-primary" data-bs-target="#processModal" data-bs-dismiss="modal"
              @click="updateEvent">儲存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import { authentication, my } from "resource";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'

export default {
  name: "Home",
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center align-middle",
      table: null,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectDismissStatus: 0,
      emergencyEventList: [],
      selectedEvent: null,
      dismissedContent: '',
      inputContent: '',
      inputEventContent:'',
      accountName: '',

      selectTimePeriod: -1, // -1 全部， 1日間, 0夜間
      isWaitResult: false,

      batchStatus: false, // 批次處理狀態 (是否開啟批次處理)
      selectedItems: [], // 批次處理選擇的結果項目
      selectAll: false, // 全選
      currentPage:null,
      maxSelectTime: Utils.getLastestTime(),
      

      
    };
  },
  computed: {
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),


    sosScenicArea() {
      return this.myScenicAreaList.filter(
        (s) =>
          s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS
      );
    },

    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
  },
  watch:{
    currentPage:{
      handler(newVal){
        this.selectedItems = []; //清空checkbox選擇
        this.selectAll = false; //取消全選
      },
      deep:true
    }
  },
  methods: {
    async queryCSV() {
      this.isWaitCCTVList = true
      const emergencyEventList = await this.searchElk()
      if (Utils.isEmptyObject(emergencyEventList)) {
        alert('此搜尋沒有資料')
        return
      }

      const csvContent = [['通報時間', '風景區', '位置', '時段', '解除警報內容', '填寫帳號', '填寫時間']]

      emergencyEventList.forEach(item => {
        const row = []
        row.push(this.getTime(item.eventTime))
        row.push(item.scenicAreaName)
        row.push(item.placeName)
        row.push(item.timePeriodContent)
        row.push(item.dismissContent)
        row.push(this.getFilledAccount(item))
        row.push(this.getFilledTime(item))

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_警報處理.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    async queryElk() {
      this.isWaitCCTVList = true
      this.emergencyEventList = await this.searchElk();
      this.updateTable()
      this.isWaitCCTVList = false
      this.selectedItems = []; //清空checkbox選擇

    },

    switchBatchEdit(){
      this.batchStatus = !this.batchStatus;
      this.selectedItems = []; //清空checkbox選擇
    },

    toggleSelectAll(){
      // console.log("selectAllItems")
      this.selectAll = !this.selectAll; // 全選狀態切換
     
      if (this.selectAll) {
      //為選擇全選時，選擇第一頁的所有項目

      let currentPageData = $('#willProcessSos').DataTable().rows({ page: 'current' }).data();
        let a =[];
        for (let i = 0; i < currentPageData.length; i++) {
          a.push(currentPageData[i][0]);
        }
      //使用正規表達式取得數字
      let numbers = a.map(item => {
        let match = item.match(/\d+/); 
        return match ? parseInt(match[0], 10) : null
      }
        )

        // console.log("a",a);
        // console.log("numbers",numbers);

      // 1. 取得目前該頁的items index
      // 2. 使用 index 取出該 item 的 eventId

      let eventIdList =[];
      for (let i = 0; i < numbers.length; i++) {
        eventIdList.push(this.emergencyEventList[numbers[i]-1].eventId);  
      }

      // console.log("b",eventIdList); 
      this.selectedItems = eventIdList;

      } else {
        //為單選時，清空全選項目
        this.selectedItems = [];
    
        // this.selectedItems = this.items.map(item => item.eventId);
        // console.log("selectItem",this.selectedItems)
      }
      
    },

    editBatchItems(){
      if(this.selectedItems.length<1){
        alert('請選擇要編輯的項目');

      }else{
        $('#processModal').modal('show');
      }
      console.log("editBatchItems",this.selectedItems)
    },

    async searchElk() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }

      //如果this.selectDismissStatus為 -1，則查全部
      // if(this.selectDismissStatus === -1){
      //   this.selectDismissStatus = null;
      // }


      const condition = {
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        scenicAreaId: this.selectScenicAreaId,
        dismissStatus: this.selectDismissStatus
        // dismissStatus: -1

      }

      await this.$store.dispatch('emergencyEvent/getEmergencyEvents', condition)
      const emergencyEventList = this.$store.getters['emergencyEvent/getEvents']
      return this.filterTimePeriod(emergencyEventList)
    },

    filterTimePeriod(emergencyEventList) {
      if(Utils.isEmptyObject(emergencyEventList)) {
        return []
      }

      //設定時段
      emergencyEventList.forEach(item => { 
        const momentTime = moment(item.eventTime)
        const momentDate = momentTime.format('YYYY/MM/DD')
        let isDayTime = momentTime.isBetween(moment(`${momentDate} 08:00`, 'YYYY/MM/DD hh:mm'), moment(`${momentDate} 17:30`, 'YYYY/MM/DD hh:mm'))
        item.timePeriod = isDayTime? 1 : 0
        item.timePeriodContent = isDayTime? '日間' : '夜間'
      })

      
      if(this.selectTimePeriod === -1) {
        return emergencyEventList
      }

      return emergencyEventList.filter(item => item.timePeriod === this.selectTimePeriod)
    },

    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return '-'
      }
      return moment(time).format('YYYY/MM/DD HH:mm')
    },
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },


    getFilledAccount(item) {
      if (Utils.isEmptyObject(item.fillAccount)) {
        return '-'
      }

      if (!item.isDismiss)
        return ''
      else
        return item.fillAccount
    },

    getFilledTime: function (item) {
      if (Utils.isEmptyObject(item.fillTime)) { // 沒有填入帳號不該有填入時間
        return '-'
      }

      if (!item.isDismiss)
        return ''
      else
        return this.getTime(item.fillTime)
    },

    selectEvent(item) {
      this.selectedEvent = Object.assign({}, item)

      if (!this.selectedEvent.isDismiss) {
        this.dismissedContent = '',
        this.inputContent = ''
      } else {
        this.selectEventDescribe();
        // if (this.selectedEvent.dismissContent === CONST.REASON_ONE || this.selectedEvent.dismissContent === CONST.REASON_TWO) {
        //   this.dismissedContent = this.selectedEvent.dismissContent
        //   this.inputContent = ''
        // } else {
        //   this.dismissedContent = CONST.REASON_THREE
        //   this.inputEventContent = this.selectedEvent.dismissContent
        // }
      }
    },

    selectEventDescribe(){
      // 請用 switch 判斷若this.selectedEvent.dismissContent === CONST.REASON_ONE 、CONST.REASON_TWO則return
      switch (this.selectedEvent.dismissContent) {
        case CONST.REASON_ONE:
          this.dismissedContent = this.selectedEvent.dismissContent;
          this.inputContent = '';
          break;
        case CONST.REASON_TWO:
               this.dismissedContent = this.selectedEvent.dismissContent;
          this.inputContent = '';
          break;
        case CONST.REASON_THREE:
          this.dismissedContent = CONST.REASON_THREE;
          this.inputContent = this.selectedEvent.dismissContent;
          break;

        case CONST.REASON_FOUR:
          this.dismissedContent = CONST.REASON_FOUR;
          this.inputEventContent = this.selectedEvent.dismissContent;

          console.log("inputEventContent",this.inputEventContent);
          break;
          
        case CONST.REASON_FIVE:
          this.dismissedContent = CONST.REASON_FOUR;
          this.inputEventContent = `${this.selectedEvent.dismissContent}`;

          console.log("inputEventContent",this.inputEventContent);
          break;
      }

    },

    async updateEvent() {

      if (Utils.isEmptyObject(this.dismissedContent) ||
        (this.dismissedContent === CONST.REASON_FIVE && Utils.isEmptyObject(this.inputContent))
      ) {
        alert('請填寫原因')
        return
      }

      const event = {
        fillAccount: this.accountName,
        content: this.dismissedContent === CONST.REASON_FIVE ? this.inputContent : this.dismissedContent,
        isDismiss: true
      }

      console.log("event",event);
      if(this.batchStatus){
        //若為多選狀態
        event.deviceEventIds = this.selectedItems;
      }else{
        //若為單選狀態
        event.deviceEventIds = [this.selectedEvent.eventId];
      }


      const result = await this.$store.dispatch('emergencyEvent/postEmergencyEvent', event)
      //等待上方函式完成後，若成功再接著執行
     
      if(result.success){
        this.emergencyEventList = this.$store.getters['emergencyEvent/getEvents']
        this.selectedItems = []; //清空checkbox選擇
        this.selectAll = false; //取消全選
        this.updateTable();
        this.batchStatus = false;
        alert('編輯成功')
      }
      else{
        alert('編輯失敗')
      }
    },

    initTable: function () {
      this.table = $("#willProcessSos").DataTable({
        aoColumns: [
          ...new Array($("#willProcessSos th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });

      this.table.on('page.dt', () => {
        const pageInfo = this.table.page.info();
        this.currentPage = pageInfo.page + 1;
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },

  },
  mounted() {
    this.updateTable()
    my.info().then(a => {
      this.accountName = a.body.name;
    });

  },

};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
